<script>
export default {
  name: 'ClickFireEvent',
  props: {
    value: {
      required: true,
    },
    fire: {
      type: String,
      required: true,
    },
    listen: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isSelected: false,
    };
  },
  created() {
    const handler = value => {
      this.isSelected = value.toString() === this.value.toString();
    };
    window.EventBus.listen(this.fire, handler);
    if (this.listen) {
      window.EventBus.listen(this.listen, handler);
    }

    this.$once('hook:beforeDestroy', () => {
      window.EventBus.unlisten(this.fire, handler);
      if (this.listen) {
        window.EventBus.unlisten(this.listen, handler);
      }
    });
  },
  methods: {
    update() {
      this.isSelected = true;
      window.EventBus.fire(this.fire, this.value);
    },
  },
  render() {
    return this.$scopedSlots.default({
      update: this.update,
      isSelected: this.isSelected,
    });
  },
};
</script>
